module.exports = __webpack_public_path__ + "img/mobile scanner stand53.ec1df4ce.jpg";